<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 棋盘系统
                </el-breadcrumb-item>
				<el-breadcrumb-item>棋手管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-select v-model="query.sectId" placeholder="请选择棋派" filterable style="width:200px">
					<el-option key="" label="请选择棋派" value=""></el-option>
					<el-option v-for="item in chessSectKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.belongTo" placeholder="请选择适用对象" style="width:150px">
					<el-option key="" label="请选择适用对象" value=""></el-option>
					<el-option key="0" label="QQ" value="0"></el-option>
					<el-option key="1" label="微信" value="1"></el-option>
				</el-select>&nbsp;
                <el-input v-model="query.name" placeholder="联系人" class="handle-input mr10" style="width:150px"></el-input>
				<el-input v-model="query.account" placeholder="账号" class="handle-input mr10" style="width:150px"></el-input>
				<el-input v-model="query.nickname" placeholder="昵称" class="handle-input mr10" style="width:150px"></el-input>
				<el-select v-model="query.defaultContact" placeholder="请选择联系人类型" style="width:150px">
					<el-option key="" label="请选择联系人类型" value=""></el-option>
					<el-option key=true label="默认联系人" value=true></el-option>
					<el-option key=false label="非默认联系人" value=false></el-option>
				</el-select>&nbsp;
				<el-checkbox v-model="query.toBeReminded" placeholder="待联系" style="padding:10px;">待联系</el-checkbox>&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column prop="sectName" label="棋派名称"></el-table-column>
                <el-table-column prop="name" label="棋手姓名" width="150"></el-table-column>
				<el-table-column prop="nickname" label="昵称(备注)" width="240">
					<template slot-scope="scope">
						{{scope.row.nickname}}{{scope.row.remarksName?"（" + scope.row.remarksName + "）":""}}
					</template>
				</el-table-column>
				<el-table-column prop="belongTo" label="来源" width="80" :formatter="belongToFormat"></el-table-column>
				<el-table-column prop="sourceName" label="来源名称" width="150"></el-table-column>
				<!--<el-table-column prop="defaultContact" label="默认联系人" width="80">
					<template slot-scope="scope">
						{{scope.row.defaultContact?"是":"否"}}
					</template>
				</el-table-column>-->
				<el-table-column prop="latestContactTime" label="最近联系时间" width="160">
					<template slot-scope="scope">
						{{scope.row.latestContactTime?scope.row.latestContactTime:'--'}}
					</template>
				</el-table-column>
				<el-table-column prop="createTime" label="创建时间" width="160"></el-table-column>
                <el-table-column label="操作" width="150" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
							v-if="controll['edit']"
                        >编辑</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if="controll['delete']"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-upload
					style="float:left"
					class="upload-demo mr10"
					accept=".xls,.xlsx"
					action= "/blob/chess-player/import-players"
					:on-success="uploadSuccess"
					:show-file-list = "false"
					v-if="controll['import']"
					list-type="picture">
					<el-button size="small" type="primary" icon="el-icon-folder-add" v-if="controll['import']">导入棋手</el-button>
				</el-upload>
				<el-button
					style="float:left"
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
					v-if="controll['add']"
                >添加记录</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="预览" :visible.sync="previewVisible" width="75%">
            <el-table
                :data="previewData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				height="500px"
				stripe
            >
                <el-table-column prop="sectName" label="棋派名称"></el-table-column>
				<el-table-column prop="name" label="棋手姓名" width="120"></el-table-column>
				<el-table-column prop="remarksName" label="备注名称" width="200"></el-table-column>
				<el-table-column prop="nickname" label="昵称" width="200"></el-table-column>
				<el-table-column prop="account" label="账号" width="150"></el-table-column>
				<el-table-column prop="belongTo" label="来源" width="80" :formatter="belongToFormat"></el-table-column>
				<el-table-column prop="sourceName" label="来源名称" width="160"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
				<el-button @click="previewVisible = false">取 消</el-button>
				<el-button type="primary" @click="save">保存</el-button>
            </span>
        </el-dialog>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="30%">
            <el-form ref="form" :model="form" label-width="120px" :rules="rules">
				<el-form-item label="棋派名称" prop="sectId">
                    <el-select v-model="form.sectId" placeholder="请选择棋派" filterable>
						<el-option key="" label="请选择棋派" value=""></el-option>
						<el-option v-for="item in chessSectKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
                </el-form-item>
				<el-form-item label="棋手姓名" prop="name" style="padding-right:50px">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
				<el-form-item label="备注名称" prop="remarksName" style="padding-right:50px">
                    <el-input v-model="form.remarksName"></el-input>
                </el-form-item>
				<el-form-item label="账号" prop="account" style="padding-right:50px">
                    <el-input v-model="form.account"></el-input>
                </el-form-item>
				<el-form-item label="昵称" prop="nickname" style="padding-right:50px">
                    <el-input v-model="form.nickname"></el-input>
                </el-form-item>
				<el-form-item label="适用于" prop="belongTo">
					<el-select v-model="form.belongTo" placeholder="请选择适用对象">
						<el-option key="" label="请选择适用对象" value=""></el-option>
						<el-option :key="0" label="QQ" :value="0"></el-option>
						<el-option :key="1" label="微信" :value="1"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="来源名称" prop="sourceName" style="padding-right:50px">
                    <el-input v-model="form.sourceName"></el-input>
                </el-form-item>
                <el-form-item label="默认联系人" prop="defaultContact">
                   <el-switch v-model="form.defaultContact"></el-switch>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchChessPlayerData, saveChessPlayer, deleteChessPlayer, getChessPlayer, getChessSectKV, saveChessPlayerBatch } from '../../../api/index';
export default {
    name: 'chess-player',
    data() {
        return {
            query: {
                code: '',
                name: '',
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
			title:"",
			isDisabled:false,
			rules: {
				sectId: [{ required: true, message: '请选择棋派', trigger: 'blur' }],
                name: [{ required: true, message: '联系人不能为空', trigger: 'blur' }],
				belongTo: [{ required: true, message: '请选择适用对象', trigger: 'blur' }],
				account: [{ required: true, message: '账号不能为空', trigger: 'blur' }],
				nickname: [{ required: true, message: '昵称不能为空', trigger: 'blur' }],
            },
			chessSectKV:[],
			previewVisible:false,
			previewData:[],
			uuid:"",
			belongToKV:{"0":"QQ","1":"微信"},
			controll:{}
        };
    },
    created() {
		this.controll = getControll("chess-player");
		this.getChessSects();
        this.getData();
    },
    methods: {
		belongToFormat(row, column, cellValue) {
			return this.belongToKV[cellValue];
		},
		//获取棋派
		getChessSects() {
			getChessSectKV().then(res => {
				if (res.code == 0) {
					this.chessSectKV = res.data;
				} else {
					this.$message.error(`获取棋派信息失败！` + res.message);
				}
			});
		},
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchChessPlayerData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteChessPlayer([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
		//添加操作
		handleAdd() {
			this.form = {};
			this.title = "添加新纪录";
			this.isDisabled = false;
			this.editVisible = true;
		},
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
            //this.form = row;
			this.title = "编辑";
			this.isDisabled = true;
			getChessPlayer(row.id).then(res => {
				if (res.code == 0) {
					this.form = res.data;
					this.editVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					saveChessPlayer(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							//this.$message.success(`修改第 ${this.idx + 1} 行成功`);
							if (typeof(this.form.id) == "undefined") {
								this.getData();
							} else {
								this.$set(this.tableData, this.idx, this.form);
							}
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		uploadSuccess(response, file, fileList) {
			if (response.code == 0 ) {
				this.previewData = response.data.obj;
				this.uuid = response.data.uuid;
				this.previewVisible = true;
			} else {
				this.$message.error(response.message);
			}
		},
		save() {
			saveChessPlayerBatch(this.uuid).then(res => {
				if (res.code == 0) {
					this.$message.success('保存成功！');
					this.previewVisible = false;
					this.getData();
					this.getChessSects();
				} else {
					this.$message.error(`保存失败！` + res.message);
				}
			});
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
